import { AccessTokenDto } from '@api/keycloak';
import { jwtDecode } from 'jwt-decode';


export class NousToken {

  constructor(
    public accessToken: string,
    public refreshToken: string,
    public expirationTime: number,
    public userId: string,
    public username: string,
    public tenantId: string,
    public organizationId: string,
    public permissions: string[],
    public roles: string[],
    public iat?: number
  ) {
  }
}

export interface DecodedToken {
  sub: string;
  preferred_username: string;
  tenantId: string;
  organizationId: string;
  permissions: string[];
  exp: number;
  iat: number;
}

export const createNousTokenFromKeyCloak = (keyCloakToken: AccessTokenDto): NousToken => {
  const {
    sub,
    'preferred_username': preferredUsername,
    tenantId,
    organizationId,
    permissions,
    exp,
    iat
  } = jwtDecode<DecodedToken>(keyCloakToken.access_token);

  return new NousToken(
    keyCloakToken.access_token,
    keyCloakToken.refresh_token,
    exp + Date.now(),
    sub,
    preferredUsername,
    tenantId,
    organizationId,
    permissions,
    [],
    iat
  );
};
